import { Team__Aliados } from "../teams/Aliados";
import { Team__Cerveceros_MAIN } from "../teams/Cerveceros_MAIN";
import { Team__Apaches } from "../teams/Apaches";
import { Team__MeanMachine } from "../teams/MeanMachine";
import { Team__Nogaleros } from "../teams/Nogaleros";
import { Team__BallBrothers } from "../teams/BallBrothers";
import { Team__UT } from "../teams/UT";
import { Team__XLobos } from "../teams/XLobos";

const Aliados = {
  team: Team__Aliados,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Apaches = {
  team: Team__Apaches,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Cerveceros = {
  team: Team__Cerveceros_MAIN,
  playingPlayers: [],

  goals: 38,
  penaltyGoals: 0,
  isWinner: false,
};

const MeanMachine = {
  team: Team__MeanMachine,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Nogaleros = {
  team: Team__Nogaleros,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const BallBrothers = {
  team: Team__BallBrothers,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const UTPaquime = {
  team: Team__UT,
  playingPlayers: [],

  goals: 47,
  penaltyGoals: 0,
  isWinner: false,
};

const XLobos = {
  team: Team__XLobos,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

// ====================
// ====================
// ====================

const Finalist = {
  team: {
    name: "Finalist",
    logoImage: null,
    teamImage: null,
    teamLogoColor: null,
    teamJerseyColor: null,
  },
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada6 = {
  jornadaPosition: 6,
  matches: [
    {
      team1: Cerveceros,
      team2: UTPaquime,

      isCompleted: true,
      isPlaying: false,
      day: "Sabado",
      date: "2025-08-02",
      time: "14:00:00",
      location: "Centro Recreativo Lebaron",
    },
  ],
};
